module.exports = __webpack_public_path__ + "media/images/logo-b28566c933a5c86337025df47585c021.svg";